import { currentTimestamp } from '@ardoq/date-time';

const offlineTimestamps = new Set<number>();

const cleanupOldTimestamps = () => {
  const cutOffPoint = currentTimestamp() - 15 * 60 * 1000;
  for (const timestamp of offlineTimestamps) {
    if (timestamp < cutOffPoint) {
      offlineTimestamps.delete(timestamp);
    }
  }
};

export const initialize = () => {
  window.addEventListener('offline', () => {
    cleanupOldTimestamps();
    offlineTimestamps.add(currentTimestamp());
  });
};

export const browserWentOffline = (transactionStartTime: number): boolean => {
  for (const timestamp of offlineTimestamps) {
    if (transactionStartTime <= timestamp) {
      return true;
    }
  }

  return false;
};
